var $ = jQuery;
var youtubeWrapper = require("../../../../themes/iaitv/javascript/src/VideoController/wrappers/youtube.js");
$(document).ready(function() {
	$("#flowplayer_video_noscript").remove();
	var seekPos = window.GLOBAL_VARS.startTime;
	var plOverlay = document.createElement("div");
	var AnimationTime = 300; // Animation fade in/fade out time in ms for the content overlay.
	var parts = seekPos.split(":");
	if (parts.length == 2) {
		seekPos = parseInt((parts[0] * 60), 10) + parseInt(parts[1], 10);
	} else if (parts.length == 3) {
		seekPos = parseInt((parts[0] * 60 * 60), 10) + parseInt((parts[1] * 60), 10) + parseInt(parts[2], 10);
	} else {
		seekPos = 0;
	}
	var type = window.GLOBAL_VARS.type;
	function done() {
		this.setVolume(100);
	}
	// todo
	var handler1 = function () {
		window.open("https://iai.tv");

	}
	var handler2 = function () {
		window.open("https://iai.tv/register");

	}
	var opts = {
			'domElementId':'flowplayer',
			'id': 'playerID',
			'width': window.GLOBAL_VARS.width,
			'height': window.GLOBAL_VARS.height,
			'file': window.GLOBAL_VARS.file,
			'playlist': [window.GLOBAL_VARS.slideOne, window.GLOBAL_VARS.file, window.GLOBAL_VARS.slideTwo],
			'autostart':false,
			'bufferlength':2,
			'controls':window.GLOBAL_VARS.controls,
			events:{
					onPlaylistItem:  function() {
						if (this.getRenderingMode() != "html5"){
							if (this.getPlaylistIndex()==1) {
								document.getElementById(this.id+"_wrapper").removeEventListener("click", handler1);
							} else if (this.getPlaylistIndex()==2) {
								document.getElementById(this.id+"_wrapper").addEventListener("click", handler2);
							}
						}
					} ,
				onPlay:function(event) {
					//todo
					if (this.getPlaylistIndex()==0) {
						if (this.getRenderingMode() != "html5"){
							document.getElementById(this.id+"_wrapper").addEventListener("click", handler1);
						}
					}
					var i = this.getPlaylistIndex();
					if (i!=1) {
						if (this.getRenderingMode() == "html5"){
							var theBody = document.getElementById(this.id);
						} else {
							var theBody = document.getElementById(this.id+"_wrapper");
						}
						var playerWidthPX2 = theBody.style.width;
						var playerWidthPX = parseFloat(playerWidthPX2);
						var playerHeightPX2 = theBody.style.height;
						var playerHeightPX = parseFloat(playerHeightPX2);
						theBody.appendChild(plOverlay);
						plOverlay.setAttribute('id', 'hyperlink');
						plOverlay.style.height = playerHeightPX2;
						plOverlay.style.width = playerWidthPX2;
						plOverlay.style.position = "relative";
						plOverlay.setAttribute('frameBorder', '0');
						plOverlay.style.top = "0px";
						plOverlay.style.left = "0px";
						plOverlay.style.textAlign = "center";
						plOverlay.style.cursor = "pointer";
						plOverlay.style.display = "block";
						plOverlay.onclick = function(){
							if (i==0) {
								window.open("https://iai.tv");
							}
							else {
								window.open("https://iai.tv/register");
							}
							plOverlay.style.display = "none";
						}
						plOverlay.style.cursor = "pointer";
					} else {
						plOverlay.style.display = "none";
					}

					if (seekPos) {
						var s = seekPos;
						seekPos = null;
						this.seek(s);
					}
				},
				onReady:done
			}
	};

	if (type === "youtube") {
		youtubeWrapper(opts);
	}
});
